module.exports = __webpack_public_path__ + "img/play-button.6319ac16.png";